import { Controller } from "@hotwired/stimulus"
import { showConfirmModal } from "../lib/custom_confirm"

// #10907 impersonation reply gate (client half). The SERVER is authoritative —
// any tokenless submit while impersonating creates nothing — this controller
// only provides the styled confirmation UX (focus-trapped gl-modal shell;
// Cancel is the safe default, Escape/backdrop resolve false).
//
// Mounted on the warning alert the server re-rendered into the Work Ticket
// frame after refusing a submit (_impersonation_reply_warning). It prompts on
// connect; Continue writes the fresh identity-bound token into the form's
// hidden field and resubmits, Cancel leaves the composer (typed body
// preserved) alone. A stale token simply round-trips: the server refuses again
// and re-renders a fresh one.
export default class extends Controller {
  static values = {
    token: String,
    agentName: String,
    formId: String,
    tokenInputId: String,
  }

  connect() {
    // Fire-and-forget: connect() must not be async for Stimulus.
    this.promptForForm(this.targetForm())
  }

  async promptForForm(form) {
    const confirmed = await showConfirmModal(
      `If you continue, this reply will be posted as ${this.agentNameValue} — ` +
        "not as GOAT Support. Exit Sign In As before replying if this " +
        "message is intended to come from Support.",
      {
        title: `You’re signed in as ${this.agentNameValue}`,
        variant: "danger",
        icon: "ph-fill ph-user-switch",
        confirmText: `Continue as ${this.agentNameValue}`,
        cancelText: "Cancel",
      },
    )
    if (!confirmed || !form) return

    this.writeToken(form)
    form.requestSubmit()
  }

  targetForm() {
    return document.getElementById(this.formIdValue)
  }

  // The frame renders a dedicated hidden field; fall back to any same-named
  // field, then create one, so a partial that drops the id still submits.
  writeToken(form) {
    let input = this.hasTokenInputIdValue && this.tokenInputIdValue
      ? document.getElementById(this.tokenInputIdValue)
      : null
    input ||= form.querySelector("input[name='impersonation_confirmation_token']")
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = "impersonation_confirmation_token"
      form.appendChild(input)
    }
    input.value = this.tokenValue
  }
}
